import {
	Dropdown,
	DropdownMenuButton,
	IconButton,
} from "@alm/flow-ds/components";
import api from "lib/api";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { exportFile } from "utils/exportFile";
import DeleteDialog from "../DeleteDialog";
import { DefinitionType } from "./DefinitionsList";
import CardColumn from "components/CardColumn";

type Props = {
	definitionId: string;
	definitionEntity: string;
	definition: DefinitionType;
	setAlert: React.Dispatch<React.SetStateAction<string>>;
};

export default ({
	definitionId,
	definitionEntity,
	definition,
	setAlert,
}: Props) => {
	const { t } = useTranslation();

	const [isOpen, setIsOpen] = useState(false);

	const downloadForm = useCallback(async (definitionId: string) => {
		const definition = await api.definitions.getFormDefinition(
			definitionId
		);
		if (definition) {
			const json = JSON.stringify(definition, undefined, 4);
			exportFile(definitionId, json, "json");
		}
	}, []);

	const deleteForm = useCallback(
		async (definitionId: string) => {
			const isDeleted = await api.definitions.deleteDefinition(
				definitionId
			);
			setAlert(
				isDeleted
					? `deleteSuccess/${definitionId}`
					: `deleteError/${definitionId}`
			);
			window.scrollTo(0, 0);
		},
		[setAlert]
	);

	return (
		<>
			<CardColumn
				className="form-definition-card__id text-truncate"
				width="lg">
				{
					<a
						href={`/formdesigner/create?formDefinition=${definitionId}`}>
						{definitionId}
					</a>
				}
			</CardColumn>
			<CardColumn
				className="form-definition-card__entity text-truncate"
				width="xl">
				{definitionEntity}
			</CardColumn>
			<CardColumn
				className="form-definition-card__label text-truncate"
				width="fill">
				{definition.formLabel}
			</CardColumn>
			<CardColumn className="form-definition-card__menu">
				<Dropdown
					className="save-dropdown"
					id="save_dropdown"
					menuBtn={
						<IconButton
							icon="ellipsis-v"
							label={`${definitionId}-dropdown`}
							className={`btn-basic--default`}
						/>
					}
					align="right">
					<DropdownMenuButton
						label={t("common.labels.download")}
						onClick={() => downloadForm(definitionId)}
					/>

					<DropdownMenuButton
						onClick={() => {
							setIsOpen(true);
						}}
						label={t("common.labels.delete")}
					/>
				</Dropdown>
				<DeleteDialog
					name={definitionId}
					deleteElement={async () => await deleteForm(definitionId)}
					type={"definition"}
					isOpen={isOpen}
					setIsOpen={setIsOpen}
				/>
			</CardColumn>
		</>
	);
};
